<template>
  <div class="not-printing">
      <div class="menu btn1 header_toggle" data-menu="1" :class="showNavbar ? 'open':''" @click="showNavbar = !showNavbar">
        <div class="icon-left"></div>
        <div class="icon-right"></div>
      </div>

      <header class="header">
        <!-- Left Side -->
        <div>
            <div class="header_img">
                <i class="fa-solid fa-bars"></i>
            </div>
            <span>{{page_title}}</span>
        </div>

        <!-- Rigth Side -->
        <div>
          <span>{{`Hola, ${user.name}`}}</span>
            <!-- Buscador - Notificaciones - Nueva factura -->
        </div>
      </header>

      <!-- Agregar estilos del SHOW a los estilos de la clase l-navbar -->
      <div class="l-navbar show" id="nav-bar">
          <nav class="nav">
            <div>
              <a href="/" class="nav_logo">
                <span class="nav_logo-name text-center fs-3">Jarvis</span>
              </a>

              <!-- <div class="profile_info mb-3 mx-auto">
                  <div class="no_image"></div>
                  <div class="col-6 flex-column">
                      <span class="col-12 fw-bold">{{ user.name }}</span>
                      <span class="col-12">{{ user.roles[0].name }}</span>
                  </div>
              </div> -->

              <div class="nav_list">
                <p class="fw-bold">Menu principal</p>

                <div class="href_links" :class="(selectedLink == 'dashboard') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/" :class="selectedLink=='dashboard' ? 'active':'' " @click="selectMenu('dashboard')">
                    <span class="nav-icon">
                      <i class="bi bi-grid-1x2-fill"></i>
                    </span>
                    <span class="nav_name">Dashboard</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'facturacion') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/invoice" :class="selectedLink=='facturacion' ? 'active':'' " @click="selectMenu('facturacion')">
                    <span class="nav-icon">
                      <i class="bi bi-pass-fill"></i>
                    </span>
                    <span class="nav_name">Facturación</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'inventario') ? 'show_div':'' ">
                <!-- <div v-if="havePermission('product', 'get')" class="href_links" :class="(selectedLink == 'inventario') ? 'show_div':'' "> -->
                  <div></div>
                  <a class="nav_link" href="/product" :class="selectedLink=='inventario' ? 'active':'' " @click="selectMenu('inventario')">
                    <span class="nav-icon">
                      <i class="bi bi-box-seam-fill"></i>
                    </span>
                    <span class="nav_name ">Productos</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'transacciones') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/invoice/invoices-view" :class="selectedLink=='transacciones' ? 'active':'' " @click="selectMenu('transacciones')">
                      <span class="nav-icon">
                        <i class="bi bi-activity"></i>
                      </span>
                    <span class="nav_name ">Transacciones</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'cierreCaja') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/cashregister" :class="selectedLink=='cierreCaja' ? 'active':'' " @click="selectMenu('cierreCaja')">
                      <span class="nav-icon">
                        <i class="bi bi-shield-lock-fill"></i>
                      </span>
                    <span class="nav_name ">Cierres de caja</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'gastos') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/spend" :class="selectedLink=='gastos' ? 'active':'' " @click="selectMenu('gastos')">
                      <span class="nav-icon">
                        <i class="bi bi-briefcase-fill"></i>
                      </span>
                    <span class="nav_name ">Gastos</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'reportes') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/home/reports" :class="selectedLink=='reportes' ? 'active':'' " @click="selectMenu('reportes')">
                      <span class="nav-icon">
                        <i class="bi bi-bar-chart-line-fill"></i>
                      </span>
                    <span class="nav_name">Reportes</span>
                  </a>
                </div>

                <p class="fw-bold">Otras opciones</p>
                <div class="href_links" :class="(selectedLink == 'permisos') ? 'show_div':'' ">
                  <a class="nav_link" href="/permission" :class="selectedLink=='permisos' ? 'active':'' " @click="selectMenu('permisos')">
                      <span class="nav-icon">
                        <i class="bi bi-person-fill"></i>
                      </span>
                    <span class="nav_name ">Roles y permisos</span>
                  </a>
                </div>

                <div class="href_links" :class="(selectedLink == 'usuarios') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/user" :class="selectedLink=='usuarios' ? 'active':'' " @click="selectMenu('usuarios')">
                      <span class="nav-icon">
                        <i class="bi bi-people-fill"></i>
                      </span>
                    <span class="nav_name">Usuarios</span>
                  </a>
                </div>
                <!-- <div class="href_links" :class="(selectedLink == 'configuracion') ? 'show_div':'' ">
                  <div></div>
                  <a class="nav_link" href="/user" :class="selectedLink=='configuracion' ? 'active':'' " @click="selectMenu('configuracion')">
                    <span class="nav-icon">
                      <i class="bi bi-gear-fill"></i>
                    </span>
                    <span class="nav_name ">Configuración</span>
                  </a>
                </div> -->
              </div>
            </div>

            <a @click.prevent="logOut" class="nav_link">
              <i class="bi bi-door-open-fill"></i>
              <span class="nav_name">Cerrar sesión</span>
            </a>
          </nav>
      </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        showNavbar : false,
        selectedLink: 'dashboard',
      }
    },
    props: {
      page_title : String || Text,
      user: Object
    },
    methods:{
      logOut() {
        axios.post('/logout',{})
        .then( location.href= '/')
      },

      selectMenu(menu) {
        // Saving navbar selection
        window.sessionStorage.setItem('navbarSelection', menu);
        this.selectedLink = sessionStorage.getItem('navbarSelection');
      },
    },
    created(){
      let value = sessionStorage.getItem('navbarSelection') || 'dashboard'
      this.selectedLink = value;
    }
  }
</script>

<style lang="scss" scoped>
  /* Navbar */
  .header {
      width:82%;
      position: fixed;
      top: 0;
      right: 0;

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: .8rem 1rem;
      background-color: var(--white-color);
      z-index: var(--z-fixed);
      transition: .5s;
      border-bottom: 1px solid #EEEEEE;

      div {
          display: flex;
          flex-direction: row;
          align-items: center;

          span{
              font-size: var(--font-title);
              font-weight: bold;
          }
      }
  }

  header:first-child{
      justify-content: center;
  }

  /* Menu Button */
  .header_toggle {
      color:black;
      font-size: 1.5rem;
      border: 0;
      background: none;
      top: -5px;
      left: 1rem;
      cursor: pointer;
      position: fixed;
      z-index: 200;
      display: none;
  }

  .header_img {
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      border-radius: 50% !important;
      overflow: hidden
  }

  .header_img img {
      position: fixed;
      width: 40px
  }

  .l-navbar {
      position: fixed;
      top: 0;
      left: -11%;
      width: 18%;
      height: 100%;
      // padding: 0.5rem 1rem 0.5rem 2.2rem;
      box-shadow: -11px 0px 47px #d5caca;
      background-color: var(--first-color);
      transition: .5s;
      z-index: var(--z-fixed)
  }

  .nav {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden
  }
  .nav_logo {
      margin: 2rem 0px;
      padding-left: 2rem;
  }
  .nav_logo, .nav_link {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 1rem;
  }

  .nav_logo-icon {
      font-size: 1.25rem;
      // color: var(--white-color)
      color: black
  }

  .nav_logo-name {
      color: var(--dark-color);
      font-weight: 700
  }
  .href_links{
    position:relative;
    font-size: 16px;
  }
  .href_links.show_div{
    div{
      position: absolute;
      z-index: 4;
      width: 3px;
      height: 100%;
      background: #FFAA2B;
    }
  }
  .dropdown-opt{
      padding-left: 4rem;
      // background: var(--first-color-dark);
      background: black;

      li{
          list-style: none;
          list-style-type: none;
          padding-bottom: 0;

          a {
              color: var(--white-color);
          }

          &:first-child{
              padding-top: 0;
          }
      }

  }

  .nav_list{
    &> p{
      padding-left:2.2rem ;
      margin: 5px 0px;
    }
  }
  .nav_link {
      position: relative;
      color: var(--first-color-dark);
      margin-bottom: 0;
      transition: .3s;
      padding:4px 0 4px 2.2rem;

      &:hover {
          background: #F4FCF6;
          color: #44814E;
      }
  }

  .show {
      left: 0
  }

  .fade {
      &.show{
          width: 100%;
      }
  }

  .body-pd:not(.header_toggle) {
      padding-left: calc(var(--nav-width) + 1rem)
  }

  .active {
      font-weight: 600;
      background: #F4FCF6;
      color: #44814E;
  }

  .active::before {
      content: '';
      position: absolute;
      left: 0;
      width: 2px;
      height: 32px;
      background-color: var(--white-color)
  }

  .active_sublink {
      color: var(--white-color);
  }

  .active_sublink::before {
      content: '';
      position: absolute;
      left: 0;
      width: 2px;
      height: 21px;
      background-color: var(--white-color)
  }

  .height-100 {
      height:100vh;
  }

  .profile_info {
      display: flex;
      align-items: center;
      width: 85%;
      padding: 8px 15px;
      border: 1px solid #EEEEEE;
      border-radius: 18px;
      gap: 17px;
      img,div.no_image{
          background: var(--secondary-color-light);
          width: 24%;
          height: 46px;
          border-radius: 11px;
      }

      div {
          display: flex;
      }
  }
</style>
